import React, { useState, useEffect } from "react";

const shuffleArray = (array) => {
  return [...array].sort(() => Math.random() - 0.5);
};

const Testdayo = () => {
  // 初期プレイヤーリスト
  const initialPlayers = [
    "手に１",
    "手に2",
    "手に3",
    "手に4",
    "手に5",
    "手に6",
    "手に7",
  ];

  // "うんきよそもの",

  // 状態としてシャッフル後のプレイヤーリストを管理
  const [players, setPlayers] = useState([]);

  useEffect(() => {
    setPlayers(shuffleArray(initialPlayers));
  }, []);

  // 指定の組み合わせリスト（1-indexed → 0-indexedに変換）
  //4人の場合
  const matchOrder4 = [
    [
      [1, 2],
      [3, 4],
    ],
    [
      [1, 3],
      [2, 4],
    ],
    [
      [1, 4],
      [2, 3],
    ],
  ].map((match) => match.map((pair) => pair.map((num) => num - 1))); // 0-indexed に変換

  //5人の場合
  const matchOrder5 = [
    [
      [1, 2],
      [3, 4],
    ],
    [
      [2, 3],
      [4, 5],
    ],
    [
      [1, 4],
      [3, 5],
    ],

    [
      [1, 5],
      [2, 4],
    ],

    [
      [1, 3],
      [2, 5],
    ],
    [
      [1, 4],
      [2, 3],
    ],
    [
      [2, 4],
      [3, 5],
    ],
    [
      [1, 5],
      [3, 4],
    ],
    [
      [1, 2],
      [4, 5],
    ],
    [
      [1, 3],
      [2, 5],
    ],
  ].map((match) => match.map((pair) => pair.map((num) => num - 1))); // 0-indexed に変換

  //6人の場合
  const matchOrder6 = [
    [
      [1, 2],
      [3, 4],
    ],
    [
      [1, 2],
      [5, 6],
    ],
    [
      [3, 4],
      [5, 6],
    ],
    [
      [1, 3],
      [2, 5],
    ],
    [
      [2, 5],
      [4, 6],
    ],
    [
      [1, 3],
      [4, 6],
    ],
    [
      [1, 4],
      [2, 6],
    ],
    [
      [1, 4],
      [3, 5],
    ],
    [
      [3, 5],
      [2, 6],
    ],
    [
      [1, 5],
      [4, 6],
    ],
    [
      [1, 5],
      [2, 3],
    ],
    [
      [2, 3],
      [4, 6],
    ],
  ].map((match) => match.map((pair) => pair.map((num) => num - 1))); // 0-indexed に変換

  //7人の場合
  const matchOrder7 = [
    [
      [1, 2],
      [3, 4],
    ],
    [
      [5, 6],
      [1, 7],
    ],
    [
      [2, 3],
      [4, 5],
    ],
    [
      [6, 2],
      [1, 7],
    ],
    [
      [6, 4],
      [3, 5],
    ],
    [
      [1, 3],
      [2, 7],
    ],
    [
      [4, 5],
      [6, 7],
    ],
    [
      [2, 4],
      [1, 5],
    ],
    // [
    //   [3, 4],
    //   [1, 5],
    // ],
    // [
    //   [2, 3],
    //   [4, 5],
    // ],
  ].map((match) => match.map((pair) => pair.map((num) => num - 1))); // 0-indexed に変換

  console.log("initialPlayers:", initialPlayers);
  let matchOrder = matchOrder4;
  switch (initialPlayers.length) {
    case 4:
      matchOrder = matchOrder4;
      break;
    case 5:
      matchOrder = matchOrder5;
      break;
    case 6:
      matchOrder = matchOrder6;
      break;
    case 7:
      matchOrder = matchOrder7;
      break;
    default:
      alert("対応する人数の乱数表は作成しておりません");
  }

  // ページがロードされたときに一度だけシャッフルする
  useEffect(() => {
    const shuffled = [...initialPlayers].sort(() => Math.random() - 0.5);
    setPlayers(shuffled);
  }, []);

  return (
    <div>
      <h2>テニス ダブルス組み合わせ表</h2>
      <h3>シャッフル後のプレイヤー</h3>
      <p>{players.length > 0 ? players.join(" / ") : "Loading..."}</p>

      <table
        border="1"
        cellPadding="5"
        style={{ borderCollapse: "collapse", marginTop: "10px" }}
      >
        <thead>
          <tr>
            <th>試合番号</th>
            <th>ペア1</th>
            <th>ペア2</th>
          </tr>
        </thead>
        <tbody>
          {players.length > 0 &&
            matchOrder.map((match, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>
                  {players[match[0][0]]} & {players[match[0][1]]}
                </td>
                <td>
                  {players[match[1][0]]} & {players[match[1][1]]}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default Testdayo;
